import { WorkOrderAssetTreeType } from '@atom/types/work';
import attributeDisplayUtility from '@atom/utilities/attributeDisplayUtility';

import classes from '../workOrderDetailPdfReport.module.css';

interface Props {
  workOrderAsset: WorkOrderAssetTreeType;
}

const PhotoLogAttachmentsTable = ({ workOrderAsset }: Props) => {
  return (
    <table className={classes.collapseBorder}>
      <thead>
        <tr>
          <th className={classes.textboxTableTitle}>Photograph Log</th>
        </tr>
      </thead>
      <tbody className={classes.content}>
        {workOrderAsset.elementGroups.map(
          elementGroup =>
            elementGroup.name === 'Photograph Log' &&
            elementGroup.elements.map(element => (
              <>
                {element.attributeGroups.map(attributeGroup => {
                  const attributeGroupIds = attributeGroup.attributes;

                  return attributeGroupIds.map(key => (
                    <tr className={classes.textboxTableRow}>
                      <td
                        className={classes.value}
                        style={{ paddingLeft: '0.625rem' }}
                      >
                        {attributeDisplayUtility.display(
                          element.attributes[key].value,
                          element.attributes[key].dataType,
                          element.attributes[key].unit,
                          !!element.attributes[key].changeId,
                          element.attributes[key].newValue,
                        )}
                      </td>
                    </tr>
                  ));
                })}
              </>
            )),
        )}
      </tbody>
    </table>
  );
};

export default PhotoLogAttachmentsTable;
